import { BrowserRouter, Routes, Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css'
import CookieChecker from "./Tools/CookieChecker";
import NavbarLayout from "./components/NavAndSide/NavbarLayout";
import NavbarAndSidebar from "./components/NavAndSide/NavbarAndSidebar";
import ClientIndexPage from "./Pages/Clients/ClientIndexPage";
import ClientShowPage from "./Pages/Clients/ClientShowPage";
import WalletIndexPage from "./Pages/Wallet/WalletIndexPage";
import TreesIndexPage from "./Pages/Trees/TreesIndexPage";
import TreesCreatePage from "./Pages/Trees/TreesCreatePage";
import TreeCreateStepOnePage from "./Pages/Trees/TreeStepsPage/TreeCreateStepOnePage";
import TreeCreateStepOneOptionalPage from "./Pages/Trees/TreeStepsPage/TreeCreateStepOneOptionalPage";
import TreeCreateStepTwoPage from "./Pages/Trees/TreeStepsPage/TreeCreateStepTwoPage";
import DashboardIndexPage from "./Pages/Dashboard/DashboardIndexPage";
import LoginView from "./Pages/Login/LoginView";
import ForgotPassPage from "./Pages/Login/ForgotPassPage";
import RegisterPage from "./Pages/Login/RegisterPage";
import ReferralForm from "./Pages/ReferralLinks/ReferralLinkPage";
import BackofficePage from "./Pages/BackofficeRequest/BackofficePage";
import WithdrawalRequestPage from "./Pages/BackofficeRequest/WithdrawalRequestPage";
import Chat from "./Pages/BackofficeRequest/Chat.js";
import TransferRequestPage from "./Pages/BackofficeRequest/TransferRequestPage";
import RequestStatusPage from "./Pages/BackofficeRequest/RequeststatusPage";
import NotFound from "./Pages/OtherPages/notFound";
import SettingsPage from "./Pages/Settings/SettingsPage";
import PasswordSettingsPage from "./Pages/Settings/SettingsOption/PasswordSettingsPage";
import IBsPage from "./Pages/IBs/IBsPage";
import NavbarAndSidebarAdmin from "./components/NavAndSide/NavbarAndSidebarAdmin";
import BrokerIbs from "./components/Broker/BrokersIbs";
import TradingGroups from "./components/TradingGroups/TradingGroups";
import TransferIBsRequest from "./Pages/BackofficeRequest/TransferIBsRequest";
import BrokerTrees from "./components/BrokerTrees/BokerTrees";
import RequestStatus from "./components/RequestStatus/RequestStatus";
import LogHistory from "./components/LogHistory/LogHistory";
import Reports from "./components/Reports/Reports";
import SettingsComponents from "./components/SettingsComponents/SettingsComponents";
import TradingAccounts from "./components/Broker/TradingAccounts";
import CreateTradingAccount from "./components/Broker/CreateTradingAccount";
import CreateEditTradingAccount from "./components/Broker/CreateEditTradingAccount";
import CreateTree from "./components/BrokerTrees/CreateTree";
import EditTreePage from "./components/BrokerTrees/EditTrees";
import PaymentRules from "./components/SettingsComponents/PaymentRules";
import CompanyEntitites from "./components/SettingsComponents/CompanyEntities";
import BrokersWallets from "./components/Broker/BrokersWallets";
import CreateMAMStepOnePage from "./Pages/BackofficeRequest/CreateMAMRequest/CreateMAMStepOnePage";
import CreateMAMStepTwoPage from "./Pages/BackofficeRequest/CreateMAMRequest/CreateMAMStepTwoPage";
import CreateMAMStepThreePage from "./Pages/BackofficeRequest/CreateMAMRequest/CreateMAMStepThreePage";
import DealTreeRequestPage from "./Pages/BackofficeRequest/DealTreeRequestPage";
import AdministrationPage from "./components/Superadmin/Administration/AdministrationPage";
import MarketingResourcesPage from "./Pages/MarketingResources/MarketingResourcesPage";
import CopierPerformanceFee from "./Pages/BackofficeRequest/CopierPerformanceFee";

function App(props) {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path={"/register"} element={<NavbarLayout type={"register"}><RegisterPage /></NavbarLayout>} />
        <Route path={"/login"} element={<NavbarLayout><LoginView type="user" /></NavbarLayout>} />
        <Route path={"/admin/login"} element={<NavbarLayout><LoginView type="admin" /></NavbarLayout>} />
        <Route path={"/forgot"} element={<NavbarLayout><ForgotPassPage /></NavbarLayout>} />
        <Route path={"*"} element={
          <CookieChecker>
            <Routes>
              <Route
                path="/admin/broker-trees/edit/:id"
                element={
                  <NavbarAndSidebarAdmin sidebarOption="Broker Trees">
                    <EditTreePage />
                  </NavbarAndSidebarAdmin>
                }
              />
            <Route
                path="/admin/broker-wallets/:email"
                element={
                  <NavbarAndSidebarAdmin sidebarOption="Brokers & IBs">
                    <BrokersWallets />
                  </NavbarAndSidebarAdmin>
                }
              />

              <Route
                path="/admin/broker-trees/create"
                element={
                  <NavbarAndSidebarAdmin sidebarOption="Broker Trees">
                    <CreateTree />
                  </NavbarAndSidebarAdmin>
                }
              />

              <Route
                path="/admin/trading-accounts-groups/:accountId/edit"

                element={
                  <NavbarAndSidebarAdmin sidebarOption="Brokers & IBs">
                    <CreateEditTradingAccount />
                  </NavbarAndSidebarAdmin>
                }
              />

              <Route
                path="/admin/trading-accounts-groups/create"
                element={
                  <NavbarAndSidebarAdmin sidebarOption="Brokers & IBs">
                    <CreateTradingAccount />
                  </NavbarAndSidebarAdmin>
                }
              />

              <Route path="/admin/trading-accounts-groups" element={
                <NavbarAndSidebarAdmin sidebarOption="Brokers & IBs">

                  <TradingAccounts />



                </NavbarAndSidebarAdmin>
              } />
              <Route path={"/"} element={<NavbarAndSidebar sidebarOption="Dashboard"><DashboardIndexPage /></NavbarAndSidebar>} />
              <Route path={"/dashboard"} element={<NavbarAndSidebar sidebarOption="Dashboard"><DashboardIndexPage /></NavbarAndSidebar>} />
              <Route exact path={"/my-clients"} element={<NavbarAndSidebar sidebarOption="Clients"><ClientIndexPage /></NavbarAndSidebar>} />
              <Route exact path={"/my-clients/:id"} element={<NavbarAndSidebar sidebarOption="Clients"><ClientShowPage /></NavbarAndSidebar>} />
              <Route exact path={"/my-wallet"} element={<NavbarAndSidebar sidebarOption="Wallet"><WalletIndexPage /></NavbarAndSidebar>} />
              <Route exact path={"/my-trees"} element={<NavbarAndSidebar sidebarOption="My trees"><TreesIndexPage /></NavbarAndSidebar>} />
              <Route exact path={"/my-trees/create"} element={<NavbarAndSidebar sidebarOption="My trees"> <TreesCreatePage /> </NavbarAndSidebar>} />
              <Route exact path={"/my-trees/create/step-one"} element={<NavbarAndSidebar sidebarOption="My trees"> <TreeCreateStepOnePage /> </NavbarAndSidebar>} />
              <Route exact path={"/my-trees/create/step-one-optional"} element={<NavbarAndSidebar sidebarOption="My trees"> <TreeCreateStepOneOptionalPage /> </NavbarAndSidebar>} />
              <Route exact path={"/my-trees/create/step-two"} element={<NavbarAndSidebar sidebarOption="My trees"> <TreeCreateStepTwoPage /> </NavbarAndSidebar>} />
              <Route exact path={"/my-trees/create/step-three"} element={<NavbarAndSidebar sidebarOption="My trees"> <TreesCreatePage /> </NavbarAndSidebar>} />
              <Route exact path={"/marketing-resources"} element={<NavbarAndSidebar sidebarOption="Marketing resources"><MarketingResourcesPage /></NavbarAndSidebar>} />
              <Route exact path={"/referral-links"} element={<NavbarAndSidebar sidebarOption="Referral Links"><ReferralForm /></NavbarAndSidebar>} />
              <Route exact path={"/requests"} element={<NavbarAndSidebar sidebarOption="Requests"><BackofficePage /></NavbarAndSidebar>} />
              <Route exact path={"/requests/withdrawal"} element={<NavbarAndSidebar sidebarOption="Requests"><WithdrawalRequestPage /></NavbarAndSidebar>} />
              <Route exact path={"/requests/transfer"} element={<NavbarAndSidebar sidebarOption="Requests"><TransferRequestPage /></NavbarAndSidebar>} />
              <Route exact path={"/requests/status"} element={<NavbarAndSidebar sidebarOption="Requests"><RequestStatusPage /></NavbarAndSidebar>} />
              <Route exact path={"/requests/chat/:idChat"} element={<NavbarAndSidebar sidebarOption="Requests"><Chat /></NavbarAndSidebar>} />
              <Route exact path={"/requests/transfer-ibs"} element={<NavbarAndSidebar sidebarOption="Requests"><TransferIBsRequest /></NavbarAndSidebar>}/>
              <Route exact path={"/settings"}element={<NavbarAndSidebar sidebarOption="SettingsPage"><SettingsPage /></NavbarAndSidebar>} />
              <Route exact path="/requests/create-mam-account" element={<NavbarAndSidebar sidebarOption="Requests"><CreateMAMStepOnePage /></NavbarAndSidebar>}/>
              <Route exact path="/requests/create-mam-account/step-two"element={<NavbarAndSidebar sidebarOption="Requests"><CreateMAMStepTwoPage /></NavbarAndSidebar>}/>
              <Route exact path="/requests/create-mam-account/step-three"element={<NavbarAndSidebar sidebarOption="Requests"><CreateMAMStepThreePage /></NavbarAndSidebar>}/>
              <Route exact path="/requests/deal-tree" element={<NavbarAndSidebar sidebarOption="Requests"><DealTreeRequestPage /></NavbarAndSidebar>}/>
              <Route exact path="/requests/copier-performance-fee" element={<NavbarAndSidebar sidebarOption="Requests"><CopierPerformanceFee /></NavbarAndSidebar>}/>
              
              <Route exact path={"/admin/settings/payment-rules"}
                element={
                  <NavbarAndSidebarAdmin sidebarOption="SettingsPage">
                    <PaymentRules />
                  </NavbarAndSidebarAdmin>} />

              <Route exact path={"/admin/settings/company-entities"}
                element={
                  <NavbarAndSidebarAdmin sidebarOption="SettingsPage">
                    <CompanyEntitites />
                  </NavbarAndSidebarAdmin>} />


              <Route exact path={"/settings/password"} element={<NavbarAndSidebar sidebarOption="SettingsPage"><PasswordSettingsPage /></NavbarAndSidebar>} />
              <Route exact path={"/my-ibs"} element={<NavbarAndSidebar sidebarOption="IBs"><IBsPage /></NavbarAndSidebar>} />
              {/* admin routes */}

              <Route exact path={"/admin/requests"} element={
                <NavbarAndSidebarAdmin sidebarOption="Request Status">
                  <RequestStatus />
                </NavbarAndSidebarAdmin>} />

              <Route exact path={"/admin/broker-trees"}
                element={<NavbarAndSidebarAdmin sidebarOption="Broker Trees">
                  <BrokerTrees />
                </NavbarAndSidebarAdmin>
                } />

              <Route
                exact path={"/admin/accounts"}
                element={
                  <NavbarAndSidebarAdmin sidebarOption="Brokers & IBs">
                    <BrokerIbs />
                  </NavbarAndSidebarAdmin>
                } />

              <Route exact path={"/admin/trading-groups"} element={<NavbarAndSidebarAdmin sidebarOption="Trading Groups">
                <TradingGroups />
              </NavbarAndSidebarAdmin>} />


              <Route exact path={"/admin/settings"} element={<NavbarAndSidebarAdmin sidebarOption="Trading Accounts">
                <SettingsComponents />
              </NavbarAndSidebarAdmin>} />
              x
              <Route exact path={"/admin/logs"} element={<NavbarAndSidebarAdmin sidebarOption="Logs History">
                <LogHistory />
              </NavbarAndSidebarAdmin>} />
              <Route exact path={"/admin/reports"} element={<NavbarAndSidebarAdmin sidebarOption="Reports">
                <Reports />
              </NavbarAndSidebarAdmin>} />
              <Route exact path={"/admin/reports/full-report"} element={<NavbarAndSidebarAdmin sidebarOption="Reports">
                <Reports />
              </NavbarAndSidebarAdmin>} />
              <Route exact path={"/admin/reports/sumarize-reports"} element={<NavbarAndSidebarAdmin sidebarOption="Reports">
                <Reports />
              </NavbarAndSidebarAdmin>} />
              <Route exact path={"/admin/administration"} element={<NavbarAndSidebarAdmin sidebarOption="Administration">
                <AdministrationPage />
              </NavbarAndSidebarAdmin>} />
              <Route exact path="*" element={<NotFound />} />
            </Routes>
          </CookieChecker>} />
        <Route exact path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
